import { defaultTenantConfig, defaultConfig } from './config.default';

const config = /*#__PURE__*/ (() => ({
  ...defaultConfig,

  region: 'boe',
  avatarDomain: 'https://bits-api-boe.bytedance.net',
  host: 'http://meego.dev.bytedance.net',
  hostForGo: '/api/goLangApi',
  collectHost: 'https://dahdpa2y.fn-boe.bytedance.net',

  guideLink: 'https://bytedance.feishu.cn/docs/doccnhGBz5VDr5xFsGV9bGgcpwe',
  currentHost: 'http://localhost:8080',
  tosBucket: 'meego',
  bytereplayEnv: 'DEV',
  larkLoginHost: 'https://www.feishu-boe.cn',
  tenantConfig: defaultTenantConfig,
  showTenantIds: '6965313173725380627',
}))();

export default config;
